<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Veículos"
          buttonText="Novo veículo"
          :buttonFunction="openVehicleModal"
        />
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-select
                  v-model="typeClient"
                  :items="typesClient"
                  item-text="name"
                  item-value="code"
                  label="Tipo de cliente:"
                  prepend-icon="mdi-office-building"
                  @change="getVehicles"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-select
                  v-model="maintenanceFilter"
                  :items="maintenanceFilterStates"
                  item-text="name"
                  item-value="code"
                  label="Manutenção:"
                  @change="getVehicles"
                  prepend-icon="mdi-cog"
                />
              </v-col>
            </v-flex>
          </v-row>

          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm3>
              <v-col align="center">
                <download-excel
                  :data="data"
                  :fields="json_fields"
                  name="veiculos.xls"
                >
                  <v-btn block color="success" class="white--text mt-4">
                    Exportar
                    <v-icon right>mdi-file-excel</v-icon>
                  </v-btn>
                </download-excel>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          class="elevation-1 mt-2"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.client ? item.client.name : 'Sem Cliente' }}</td>
              <td>{{ item.plate }}</td>
              <td>{{ item.imei }}</td>
              <td>
                {{ item.vehicle_model ? item.vehicle_model.model : item.model }}
              </td>
              <td>
                {{ item.garage ? item.garage.description : 'Sem Garagem' }}
              </td>
              <td>
                <ActionButton
                  message="Abrir veículo"
                  icon="mdi-lock-open"
                  color="success"
                  @onclick="openCar(item.id)"
                />
                <ActionButton
                  message="Fechar veículo"
                  icon="mdi-lock"
                  color="warning"
                  @onclick="closeCar(item.id)"
                />
                <ActionButton
                  message="Editar veículo"
                  icon="edit"
                  color="primary"
                  @onclick="editItem(item)"
                />
                <ActionButton
                  message="Excluir veículo"
                  icon="delete"
                  color="error"
                  @onclick="deleteItem(item)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Modal Reservas -->
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="requests_modal" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{
                'Este veículo possui reservas abertas!'
              }}</span>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="requests_headers"
                :items="requests"
                hide-default-footer
                class="elevation-1 mt-2"
              >
              </v-data-table>
              <v-flex xs12 style="text-align: center">
                <h2>
                  <v-icon>email</v-icon>
                </h2>
              </v-flex>
              <v-flex xs12 style="text-align: center">
                <h4>Escreva uma mensagem de cancelamento</h4>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  solo
                  label="Informe aos usuários o motivo do cancelamento..."
                  v-model="requests_cancel_message"
                  required
                ></v-textarea>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="requests_modal = false"
                >Fechar</v-btn
              >
              <v-btn color="blue darken-1" text @click="cancelRequests()"
                >Cancelar Reservas e Salvar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <!-- Modal Veiculo -->
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="register_vehicle_modal" persistent max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline">{{
                this.vehicle.id ? 'Editar veículo' : 'Novo veículo'
              }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout>
                  <v-flex xs12>
                    <v-checkbox
                      v-model="vehicle.isFakeVehicleOrInternal"
                      label="Veículo FAKE ou de USO INTERNO"
                    >
                    </v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12 md4>
                    <v-dialog
                      ref="dialog_begin"
                      v-model="fleet_start_date"
                      :return-value.sync="vehicle.fleet_start_date"
                      persistent
                      lazy
                      max-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="vehicle.fleet_start_date"
                          label="Data início do contrato de locação"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        v-model="vehicle.fleet_start_date"
                        scrollable
                        class="color"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          flat
                          color="primary"
                          @click="fleet_start_date = false"
                          >Cancelar</v-btn
                        >
                        <v-btn
                          flat
                          color="primary"
                          @click="
                            $refs.dialog_begin.save(vehicle.fleet_start_date)
                          "
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      @change="getGaragesByClient()"
                      v-model="vehicle.client_id"
                      :items="clients"
                      item-text="name"
                      item-value="id"
                      label="Cliente"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="vehicle.model_id"
                      :items="vehicleModels"
                      item-text="model"
                      item-value="id"
                      label="Modelo"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-mask="'AAA-#X##'"
                      label="Placa"
                      v-model="vehicle.plate"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="vehicle.garage_id"
                      :items="garages"
                      item-text="description"
                      item-value="id"
                      label="Garagem"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="vehicle.id_tracker"
                      :items="tracker"
                      item-text="name"
                      item-value="id"
                      label="Tipo de Rastreador"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="IMEI"
                      v-model="vehicle.imei"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="MAC ADDRESS (Bluetooth)"
                      v-model="vehicle.bluetooth_mac_address"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Nome do Bluetooth"
                      v-model="vehicle.bluetooth_device_name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="vehicle.vehicle_category_id"
                      :items="category"
                      item-text="name"
                      item-value="id"
                      label="Categoria"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Hodômetro do veículo (KM)"
                      v-mask="'#########'"
                      v-model="vehicle.odometer_adjustment"
                      required
                    ></v-text-field>
                  </v-flex>
                  <hr />
                  <br />
                  <v-flex md12>
                    <h4>Cartão Abastecimento</h4>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      type="number"
                      label="Número do Cartão"
                      v-model="vehicle.card_number"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      type="number"
                      label="Senha do cartão"
                      v-model="vehicle.card_password"
                      required
                    ></v-text-field>
                  </v-flex>
                  <hr />
                  <v-flex md12>
                    <h4>Itens do carro</h4>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      type="number"
                      label="Número de portas"
                      v-model="vehicle.doors_qtd"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <label for="model">Ar Condicionado</label>
                    <select
                      class="form-control"
                      name="air_conditioning"
                      :value="
                        vehicle.air_conditioning
                          ? vehicle.air_conditioning
                          : false
                      "
                      v-model="vehicle.air_conditioning"
                    >
                      <option value="false">Não</option>
                      <option value="true">Sim</option>
                    </select>
                  </v-flex>
                  <v-flex md6>
                    <label for="model">Câmbio do Carro</label>
                    <select
                      class="form-control"
                      name="air_conditioning"
                      v-model="vehicle.gearbox"
                    >
                      <option>Manual</option>
                      <option>Automático</option>
                      <option>CVT</option>
                    </select>
                  </v-flex>
                  <v-flex md6>
                    <label for="model">Tipo de Direção</label>
                    <select
                      class="form-control"
                      name="air_conditioning"
                      v-model="vehicle.direction_type"
                    >
                      <option>Hidráulica</option>
                      <option>Elétrica</option>
                      <option>Mecânica</option>
                    </select>
                  </v-flex>
                  <hr />
                  <v-flex md6>
                    <label for="model">Preço (HORA):</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"
                          >R$</span
                        >
                      </div>
                      <money
                        v-model="vehicle.price_hour"
                        v-bind="money"
                        class="form-control"
                      ></money>
                    </div>
                  </v-flex>
                  <v-flex md6>
                    <label for="model">Preço (KM):</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"
                          >R$</span
                        >
                      </div>
                      <money
                        v-model="vehicle.price_km"
                        v-bind="money"
                        class="form-control"
                      ></money>
                    </div>
                  </v-flex>
                  <v-flex md6>
                    <label for="model">Valor da pré autorização</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"
                          >R$</span
                        >
                      </div>
                      <money
                        v-model="vehicle.pre_authorization_value"
                        v-bind="money"
                        class="form-control"
                      ></money>
                    </div>
                  </v-flex>
                  <v-flex md6>
                    <label for="model">Preço da taxa de seguro:</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"
                          >R$</span
                        >
                      </div>
                      <money
                        v-model="vehicle.insurance_tax"
                        v-bind="money"
                        class="form-control"
                      ></money>
                    </div>
                  </v-flex>

                  <v-flex md6>
                    <label for="model"
                      >Preço do valor da franquia de seguro:</label
                    >
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"
                          >R$</span
                        >
                      </div>
                      <money
                        v-model="vehicle.insurance_value"
                        v-bind="money"
                        class="form-control"
                      ></money>
                    </div>
                  </v-flex>
                  <v-flex md6>
                    <v-checkbox
                      style="padding-top: 15px"
                      v-model="vehicle.allow_reservation_less_than_one_hour"
                      label="Permite reserva inferior a 60 minutos"
                    >
                    </v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeModal()"
                >Fechar</v-btn
              >
              <v-btn color="blue darken-1" text @click="validateUpdate()"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import VehicleController from '../../controllers/VehicleController.js';
import GarageController from '../../controllers/GarageController.js';
import VehicleTypeController from '../../controllers/VehicleTypeController.js';
import TrackerController from '../../controllers/TrackerController.js';
import VehicleCategoryController from '../../controllers/VehicleCategoryController.js';
import VehicleModelController from '../../controllers/VehicleModelController';
import VehicleHistoryController from '../../controllers/VehicleHistoryController';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import ClientController from '../../controllers/ClientController.js';
import Vehicle from '../../models/Vehicle.js';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import ActionButton from '../shared/ActionButtonsTemplate';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';

export default {
  components: {
    TitleWithButton,
    ActionButton,
  },
  created() {
    this.vehicleController = new VehicleController(this.$resource);
    this.garageController = new GarageController(this.$resource);
    this.vehicleTypeController = new VehicleTypeController(this.$resource);
    this.trackerController = new TrackerController(this.$resource);
    this.vehicleCategoryController = new VehicleCategoryController(
      this.$resource
    );
    this.vehicleModelController = new VehicleModelController(this.$resource);
    this.vehicleHistoryController = new VehicleHistoryController(
      this.$resource
    );
    this.vehicleRequestController = new VehicleRequestController(
      this.$resource
    );
    this.clientController = new ClientController(this.$resource);
    this.getVehicles();
    this.getTracker();
    this.getCategory();
    this.getModels();
    this.getClients();
  },
  data() {
    return {
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      vehicleModels: [],
      vehicle: new Vehicle(),
      garages: [{ description: 'Sem Garagem', id: null }],
      typeVehicle: [],
      tracker: [],
      category: [],
      data: [],
      plate: '',
      model: '',
      fleet_start_date: false,
      json_fields: {
        Cliente: 'client.name',
        Placa: 'plate',
        Imei: 'imei',
        Modelo: 'vehicle_model.model',
        Garagem: 'garage.description',
      },
      headers: [
        { text: 'Cliente', value: 'client.name' },
        { text: 'Placa', value: 'plate' },
        { text: 'Imei', value: 'imei' },
        { text: 'Modelo', value: 'vehicle_model.model' },
        { text: 'Garagem', value: 'garage.description' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      requests_headers: [
        { text: 'Solicitante', value: 'name' },
        { text: 'Status', value: 'code' },
        { text: 'Data de Check-in', value: 'begin_date' },
        { text: 'Data de Check-out', value: 'end_date' },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      clients: [],
      register_vehicle_modal: false,
      old_vehicle_id: null,
      vehicle_original_client_id: null,
      vehicle_original_garage_id: null,
      requests: [],
      requests_cancel_message: '',
      requests_modal: false,
      typeClient: 'all',
      typesClient: [
        {
          name: 'Todos',
          code: 'all',
        },
        {
          name: 'Condomínio',
          code: 'condominio',
        },
        {
          name: 'Concessionaria',
          code: 'concessionaria',
        },
        {
          name: 'Frotas',
          code: 'frotas',
        },
      ],
      maintenanceFilter: 'all',
      maintenanceFilterStates: [
        {
          name: 'Todos',
          code: 'all',
        },
        {
          name: 'Em manutenção',
          code: 'maintenance',
        },
        {
          name: 'Disponíveis',
          code: 'available',
        },
      ],
    };
  },
  methods: {
    getClients() {
      this.clientController.getAllClients().then(clients => {
        this.clients = clients;
        this.clients.push({ name: 'Sem Cliente', id: null });
      });
    },
    async openCar(id) {
      let res = await this.vehicleController.changeStatus(id, 'unlock');
      if (res.error) {
        this.$awn.alert('Falha o enviar comando');
      } else {
        this.$awn.success('Comando enviado!');
      }
    },
    async closeCar(id) {
      let res = await this.vehicleController.changeStatus(id, 'lock');
      if (res.error) {
        this.$awn.alert('Falha o enviar comando');
      } else {
        this.$awn.success('Comando enviado!');
      }
    },
    async editItem(item) {
      this.vehicle = Object.assign({}, item);
      // No caso da edição, buscar o hodômetro atual
      // Mecanismo de ajuste de odômetro transparente para usuário
      this.vehicle.odometer_adjustment = await this.getVehicleOdometer(
        this.vehicle.id
      );
      this.vehicle.pre_authorization_value = item.pre_authorization_value / 100;
      this.vehicle.price_km = item.price_km / 100;
      this.vehicle.price_hour = item.price_hour / 100;
      this.vehicle.insurance_tax = item.insurance_tax
        ? item.insurance_tax / 100
        : '';
      this.vehicle.insurance_value = item.insurance_value
        ? item.insurance_value / 100
        : '';
      this.getGaragesByClient();
      this.old_vehicle_id = Object.assign({}, item);
      this.register_vehicle_modal = true;
      this.vehicle_original_client_id = this.vehicle.client_id;
      this.vehicle_original_garage_id = this.vehicle.garage_id;
    },

    async getVehicleOdometer(vehicleId) {
      try {
        let infos = await this.vehicleController.getInfosByVehicleId(vehicleId);
        return infos.hodometro;
      } catch (err) {
        console.error(err);
      }
    },

    deleteItem(item) {
      this.vehicle = Object.assign({}, item);
      this.deleteVehicle();
    },

    deleteVehicle() {
      swal({
        title: 'Você tem certeza?',
        text: 'Essa ação não poderá ser desfeita!',
        icon: 'error',
        buttons: true,
        dangerMode: true,
      }).then(willDelete => {
        if (willDelete) {
          this.vehicleController.delete(this.vehicle).then(
            res => {
              this.getVehicles();
              this.$awn.success('Veículo excluído com sucesso!');
            },
            error => {
              this.$awn.alert(error.message);
            }
          );
        }
      });
    },

    getGaragesByClient() {
      if (!this.vehicle.client_id) {
        this.garages = [{ description: 'Sem Garagem', id: null }];
        this.vehicle.garage_id = this.garages[0].id;
        return;
      }
      this.garageController.get(this.vehicle.client_id).then(garages => {
        this.garages = garages;
        this.garages.push({ description: 'Sem Garagem', id: null });
        if (this.vehicle_original_client_id !== this.vehicle.client_id)
          this.vehicle.garage_id = this.garages[0].id;
      });
    },

    async getVehicles() {
      this.blockScreen = true;
      await this.vehicleController
        .getAllVehicles(this.typeClient, this.maintenanceFilter)
        .then(response => {
          this.data = response;
        })
        .catch(error => {
          this.$awn.alert('Falha ao obter veículos');
        });
      this.blockScreen = false;
    },

    async getVehicleRequest(callback = null) {
      this.blockScreen = true;
      await this.vehicleRequestController
        .getVehicleRequestsByVehicleId(this.vehicle.id)
        .then(response => {
          this.requests = response;
        })
        .catch(error => {
          this.$awn.alert('Falha ao obter as reservas do veículo');
        });
      this.blockScreen = false;
      if (callback) callback();
    },

    getTracker() {
      this.trackerController.getAllTracker().then(res => (this.tracker = res));
    },
    getCategory() {
      this.vehicleCategoryController
        .getAll()
        .then(res => (this.category = res));
    },
    getModels() {
      this.vehicleModelController.get().then(res => (this.vehicleModels = res));
    },

    async save() {
      try {
        this.blockScreen = true;
        let response = null;

        if (this.vehicle.id) {
          response = await this.vehicleController.update(this.vehicle);
        } else {
          response = await this.vehicleController.register(this.vehicle);
          if (
            (!response.ok,
            response.message ===
              'Já existe um veículo com a mesma placa registrada.')
          ) {
            const vehicle = await this.vehicleController.getVehicleByPlate(
              this.vehicle.plate
            );

            await swal({
              title: response.message,
              text: 'Você deseja reativar esse veículo?',
              icon: 'warning',
              buttons: true,
              dangerMode: true,
            }).then(async willUpdate => {
              if (willUpdate) {
                response = await this.vehicleController.update({
                  ...this.vehicle,
                  id: vehicle.id,
                  active: true,
                });
              }
            });
          }
        }

        if (response.ok) {
          this.$awn.success(response.message);
          this.getVehicles();
        } else {
          this.$awn.warning(response.message);
        }
      } catch (error) {
        this.$awn.alert(error.message);
      } finally {
        this.register_vehicle_modal = false;
        this.blockScreen = false;
        this.cleanForm();
      }
    },

    cancelRequests() {
      if (this.requests_cancel_message === '') {
        this.$awn.warning('Informe uma mensagem de cancelamento!');
        return;
      }
      this.requests.forEach(request => {
        const { id, email, begin_date, end_date, address, client_id } = request;
        const message = this.requests_cancel_message;

        this.vehicleRequestController.cancelVehicleRequest(
          id,
          'Veículo mudou de comdomínio e/ou garagem',
          { email, begin_date, end_date, message, address, client_id }
        );
      });
      this.requests_modal = false;
      this.requests_cancel_message = '';
      this.vehicle_original_client_id = this.vehicle.client_id;
      this.vehicle_original_garage_id = this.vehicle.garage_id;

      this.save();
    },

    validateUpdate() {
      if (
        (this.vehicle_original_client_id !== this.vehicle.client_id ||
          this.vehicle_original_garage_id !== this.vehicle.garage_id) &&
        this.vehicle.id
      ) {
        this.getVehicleRequest(() => {
          if (this.requests.length === 0) {
            this.save();
            return;
          }
          this.requests_modal = true;
        });
      } else this.save();
    },

    closeModal() {
      this.vehicle = {};
      console.log(this.vehicle);
      this.register_vehicle_modal = false;
    },

    openVehicleModal() {
      this.cleanForm();
      this.register_vehicle_modal = true;
    },

    cleanForm() {
      this.vehicle = new Vehicle();
    },

    handleSelectionChange(val) {
      this.selectedRow = val;
    },
  },
};
</script>
<style lang="scss">
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.new-car-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
.v-input--checkbox > .v-input__control > .v-input__slot > label {
  padding-top: 10px;
}
td.layout {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
}

.open-button {
  color: var(--primary-color);
  &:hover {
    color: var(--green-color-hover);
  }
}

.close-button {
  color: var(--red-color);
  &:hover {
    color: var(--red-color-hover);
  }
}

.car-open-buttons:hover {
  cursor: pointer;
}

.selectFilter {
  max-width: 300px;
  margin-right: 40px;
}
</style>
